const configVariables = {
    termsAndConditionsUrl: 'https://smile-academy.com.au/smile-academy-terms-and-conditions/',
    contactEmailAddress: 'info@smile-academy.com.au',
    youtubeVideo: 'https://www.youtube.com/watch?v=_dtIqoCt4SE',
    consentFormUrl: 'https://we.tl/t-G87JS7jTeL',
    marketingMaterialUrl:
        'https://smileacademycomau-my.sharepoint.com/:f:/g/personal/aurelien_smile-academy_com_au/Eh2quvnpaK9Coy_HDU4ivk0BaclXV7AX93kW2IOpSCXrVA?e=lpx8y6',
    pricingUrlAustralia: 'https://we.tl/t-otxBOutvc6',
    pricingUrlNewZealand: 'https://we.tl/t-a5RYNlLJVw',
    pricingUrlNewCaledonia: 'https://we.tl/t-EZgC86oG9X',
    // if isBackend is false, data will be mocked on the frontend. If true, if will use this config file to fetch data
    isBackend: process.env.REACT_APP_BACKEND === 'true',
    apiName: 'dentist-portal-api',
    region: 'ap-southeast-2',
    Auth: {
        email: 'admin@smile-academy.com.au', // used for local sign in only
        password: 'password',
    },
    cognito: {
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
    },
    apiEndpoint: process.env.REACT_APP_API_GATEWAY_URL,
};

export default configVariables;
